export default function Error () {
    return (
        <div>
            <h2 className="text-3xl p-10">We're sorry, there seems to be an error. Please refrain from violence.</h2>
            <iframe className=' mx-auto block 'src="https://giphy.com/embed/H54feNXf6i4eAQubud" width="480" height="405" frameBorder="0" class="giphy-embed" allowFullScreen></iframe><p><a href="https://giphy.com/gifs/chicken-bro-H54feNXf6i4eAQubud"></a></p>
        </div>
    )
}